/**
 * Floating bulk cart bar. Fixed to the viewport bottom; listens for the
 * `bulk:cart-updated` event from the order-table steppers and keeps the
 * item count + total in sync. Pads the page bottom by its own height so it never
 * covers the last table rows. Provides a Remove All confirmation flow.
 */
(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.PXUTheme && window.PXUTheme.currency) {
      return window.Shopify.formatMoney(cents, window.PXUTheme.currency.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  if (customElements.get('bulk-order-cart-bar')) return;

  class BulkOrderCartBar extends HTMLElement {
    connectedCallback() {
      this.mainEl = this.querySelector('[data-cart-bar-main]');
      this.confirmEl = this.querySelector('[data-cart-bar-confirm]');
      this.countEl = this.querySelector('[data-bulk-cart-count]');
      this.subtotalEl = this.querySelector('[data-bulk-cart-subtotal]');
      this.confirmCountEl = this.querySelector('[data-cart-bar-confirm-count]');

      this.onCartUpdated = this.onCartUpdated.bind(this);
      this.updateSpacer = this.updateSpacer.bind(this);
      document.addEventListener('bulk:cart-updated', this.onCartUpdated);
      window.addEventListener('resize', this.updateSpacer);

      var self = this;
      this.bind('[data-bulk-bar-remove-all]', function () { self.showConfirm(); });
      this.bind('[data-cart-bar-cancel]', function () { self.showMain(); });
      this.bind('[data-cart-bar-confirm-remove]', function () { self.removeAll(); });

      this.updateSpacer();
    }

    disconnectedCallback() {
      document.removeEventListener('bulk:cart-updated', this.onCartUpdated);
      window.removeEventListener('resize', this.updateSpacer);
      this.setSpacer(0);
    }

    bind(selector, handler) {
      var el = this.querySelector(selector);
      if (el) el.addEventListener('click', handler);
    }

    onCartUpdated(event) {
      this.render(event.detail.cart);
    }

    render(cart) {
      var empty = cart.item_count === 0;
      this.toggleAttribute('hidden', empty);
      if (this.countEl) this.countEl.textContent = cart.item_count;
      if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(cart.total_price);
      if (this.confirmCountEl) this.confirmCountEl.textContent = cart.item_count;
      if (empty) this.showMain(); // reset to normal state once emptied
      this.updateSpacer();
    }

    showConfirm() {
      if (this.mainEl) this.mainEl.hidden = true;
      if (this.confirmEl) this.confirmEl.hidden = false;
      this.updateSpacer();
    }

    showMain() {
      if (this.confirmEl) this.confirmEl.hidden = true;
      if (this.mainEl) this.mainEl.hidden = false;
      this.updateSpacer();
    }

    removeAll() {
      var self = this;
      var btn = this.querySelector('[data-cart-bar-confirm-remove]');
      if (btn) btn.disabled = true;

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          self.showMain();
          self.render(cart);
          document.dispatchEvent(new CustomEvent('bulk:cart-updated', { detail: { cart: cart } }));

          document.querySelectorAll('[data-bulk-item]').forEach(function (row) {
            row.dataset.cartQuantity = 0;

            var input = row.querySelector('[data-bulk-qty-input]');
            if (input) input.value = 0;

            var decreaseBtn = row.querySelector('[data-bulk-qty-decrease]');
            if (decreaseBtn) decreaseBtn.setAttribute('disabled', '');

            var removeBtn = row.querySelector('[data-bulk-remove]');
            if (removeBtn) removeBtn.setAttribute('hidden', '');

            var totalEl = row.querySelector('[data-bulk-line-total]');
            if (totalEl) totalEl.textContent = formatMoney(0);
          });

          if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
            window.PXUTheme.jsAjaxCart.updateView();
          }
        })
        .catch(function (error) { console.error(error); })
        .finally(function () { if (btn) btn.disabled = false; });
    }

    // Pad the page bottom by the bar's current height so fixed positioning never
    // hides the last rows. Zero when the bar is hidden (empty cart).
    updateSpacer() {
      var height = this.hasAttribute('hidden') ? 0 : this.offsetHeight;
      this.setSpacer(height);
    }

    setSpacer(px) {
      document.body.style.paddingBottom = px ? px + 'px' : '';
    }
  }

  customElements.define('bulk-order-cart-bar', BulkOrderCartBar);
})();
